<template>
  <!--
          作者：yel
          时间：2021-3-18
          描述：表单模板
      -->
  <div class="product">
    <!--搜索-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="用户ID">
          <el-input size="small" v-model="searchForm.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="用户昵称">
          <el-input size="small" v-model="searchForm.nickName" placeholder="请输入用户昵称"></el-input>
        </el-form-item>
        <el-form-item label="用户电话">
          <el-input size="small" v-model="searchForm.mobile" placeholder="请输入用户电话"></el-input>
        </el-form-item>
        <el-form-item label="区域">
          <el-select v-model="searchForm.province_id" clearable placeholder="省" @change="initCity">
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
          </el-select>
          <el-select v-if="searchForm.province_id!=''" clearable v-model="searchForm.city_id" placeholder="市" @change="initRegion">
            <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[searchForm.province_id]['city']"
              :key='index1'></el-option>
          </el-select>
          <el-select v-if="searchForm.city_id!=''" clearable v-model="searchForm.region_id" placeholder="区" @change="initStreet">
            <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[searchForm.province_id]['city'][searchForm.city_id]['region']"
              :key='index2'></el-option>
          </el-select>
          <el-select v-if="searchForm.region_id!=''" clearable v-model="searchForm.street_id" placeholder="街道/镇/乡">
            <el-option :label="item3.name" :value="item3.id" v-for="(item3,index3) in areaList[searchForm.province_id]['city'][searchForm.city_id]['region'][searchForm.region_id]['street']"
              :key='index3'></el-option>
          </el-select>

        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="addClick()" type="success" icon="el-icon-search" v-auth="'/plus/regionagent/regionagent/add'">添加</el-button>
        </el-form-item>
      </el-form>
    </div>



    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table  size="small" :data="tableData" border style="width: 100%" v-loading="loading">

          <el-table-column prop="id" label="ID" width="120"></el-table-column>
          <el-table-column prop="user" label="用户" >
            <template  slot-scope="scope">
               <div v-if="scope.row.user">
                  <p v-if="scope.row.user.nickName">昵称：{{scope.row.user.nickName}}</p>
                  <p v-if="scope.row.user.mobile">电话：{{scope.row.user.mobile}}</p>
                  <p class="gray9">(用户ID：{{scope.row.user_id}})</p>
               </div>
            </template>
          </el-table-column>
          <el-table-column prop="level" label="级别" width="120">
            <template  slot-scope="scope">
               <div>{{arr_text[scope.row.level]}}</div>
            </template>
          </el-table-column>

          <el-table-column prop="region" label="区域">
            <template slot-scope="scope">
              <div>{{scope.row.region}}</div>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="region" label="审核">
            <template slot-scope="scope">
              <span class="red f14" v-if="scope.row.apply_status == 10">申请中</span>
              <span class="green f14" v-else-if="scope.row.apply_status == 20">已通过</span>
              <span class="gray9 f14" v-else>驳回</span>
              <p v-if="scope.row.apply_status == 30">驳回原因：{{scope.row.reject_reason}}</p>
              <p v-if="scope.row.create_time">审核时间：{{scope.row.create_time}}</p>
            </template>
          </el-table-column> -->

          <!-- <el-table-column prop="admin_expire_date_text" label="到期时间">
            <template slot-scope="scope">
              <div>{{scope.row.admin_expire_date_text}}</div>
            </template>
          </el-table-column> -->

          <el-table-column prop="create_time" label="创建时间" width="135"></el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button @click="auditClick(scope.row)" type="text" size="small"
              v-if="scope.row.apply_status == 10"
              
              v-auth="'/plus/regionagent/regionagent/audit'">审核</el-button>
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/plus/regionagent/regionagent/edit'">编辑</el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/plus/regionagent/regionagent/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <Add v-if="open_add" :open_add="open_add" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <Edit v-if="open_edit" :open_edit="open_edit" :form="Oneform.model" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
    <Audit v-if="open_audit" :open_audit="open_audit" :model="Oneform.model" @closeDialog="closeDialogFunc($event, 'audit')"></Audit>

  </div>
</template>


<script>
  import RegionagentApi from '@/api/regionagent.js';
  import select_district from '@/utils/select.district.js';
  import Add from './dialog/Add.vue';
  import Edit from './dialog/Edit.vue';
  import Audit from './dialog/Audit.vue';
  export default {
    components: {
      /*编辑组件*/
      Add,
      Edit,
      Audit
    },
    data() {
      return {
        //加载
        loading: true,// true 为加载中   false 加载结束

        // 选项卡控制
        activeName: 'all',

        //搜索控制
        searchForm: {
          user_id: ''  ,//用户id
          nickName:'',
          mobile:'',
          merger_name:'',
          province_id: '',
          city_id: '',
          region_id: '',
          street_id: '',
        },
        arr_text:{
          '1':'省代',
          '2':'市代',
          '3':'区代',
          '4':'街道',
        },

        //表格数据
        tableData: [],/*列表数据*/
        totalDataNumber: 0,/*总条数*/
        pageSize: 20,/*一页多少条*/
        curPage: 1,/*当前是第几页*/

        /*是否打开添加弹窗*/
        open_add: false,
        open_edit: false,
        open_audit: false,
        /*选择的当前行对象数据*/
        Oneform:{
          type:'add',
          model:{}
        },
        /*省市区*/
        areaList: select_district,

      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
       // 选项卡 start
       handleClick(tab, event) {
         /*切换选项卡 */
         let self = this;
         self.curPage = 1; //变为第一页
         self.loading = true;//加载中
         self.activeName = tab.name;
         self.getData(); //获取数据
       },
       // 选项卡 end


       /*搜索查询*/
       onSubmit() {
         let self = this;
         self.loading = true;//加载中
         self.getData();//获取数据
       },

      //列表数据 start

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val; //选择的页数
        self.loading = true; //加载中
        self.getData();//获取数据
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;  //调到第一页
        this.pageSize = val; //每页多少条
        this.getData(); //获取数据
      },

      /*获取列表*/
      getData() {
        let self = this;
        let Params = {};
        Params = self.searchForm; //搜索
        Params.activeStatus = self.activeName; //选项卡
        Params.page = self.curPage; //当前页数
        Params.list_rows = self.pageSize;//每页多少条

        //请求接口
        RegionagentApi.regionagentList(Params, true).then(res => {
          self.loading = false;//加载结束
          self.tableData = res.data.list.data; //把数据给列表
          self.totalDataNumber = res.data.list.total;//一共多少条

        }).catch(error => {
          self.loading = false; //加载结束
        });
      },

      //列表数据 end

      //操作 start

      /*初始化城市id*/
      initCity() {
        this.searchForm.city_id = ''
      },
      /*初始化区id*/
      initRegion() {
        this.searchForm.region_id = ''
      },
      initStreet() {
        this.searchForm.street_id = ''
      },

      /*删除*/
      delClick: function(row) {
        let self = this;
        self.loading = true;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {

          //请求接口
          RegionagentApi.regionagentDel({
            id: row.id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          }).catch(() =>{
            self.loading = false;
          });
        }).catch(() =>{
          self.loading = false;
        });
      },
      /*审核*/
      auditClick: function(row) {
        let self = this;
        self.loading = true;
        self.$confirm('确认审核删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {

          //请求接口
          RegionagentApi.regionagentDel({
            id: row.id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          }).catch(() =>{
            self.loading = false;
          });
        }).catch(() =>{
          self.loading = false;
        });
      },

      //操作 end
      /*打开添加*/
      addClick() {
        this.Oneform.model = {};
        this.Oneform.type = 'add';
        this.open_add = true;
      },
      //编辑
      editClick($row){
        this.Oneform.model = $row;
        this.Oneform.type = 'edit';
        this.agent = $row;
        this.open_edit = true;
      },
      //详情
      dateilClick($row){
        this.Oneform.model = $row;
        this.Oneform.type = 'dateil';
        this.open_add = true;
      },
      //审核
      auditClick($row){
        this.Oneform.model = $row;
        this.Oneform.type = 'audit';
        this.open_audit = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.open_add = e.openDialog;
        this.open_edit = e.openDialog;
        this.open_audit = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/regionagent/regionagent/index.vue